import { MantineTheme } from "@mantine/core";

export const anchorComponentSettings: MantineTheme["components"]["Anchor"] = {
  defaultProps: {
    underline: true,
    color: "bay.6",
  },
};
